import Component from '../core/Component';
import {queryAll} from '../utils/dom'

export default class Form extends Component {

    prepare() {
        const inputs = queryAll('.input, .textarea', this.element);

        inputs.forEach(input => {
            input.addEventListener("change", ::this.setClass);
        });
    }

    setClass(event) {
        let input = event.target,
            input_value = input.value;

        if (input_value.trim() != '') {
            input.parentElement.classList.add("input--filled");
        } else {
            input.parentElement.classList.remove("input--filled");
        }
    }

}


// WEBPACK FOOTER //
// ./components/Form.js